import React, { useEffect } from 'react';
import AboutUs from '../../components/AboutUs/AboutUs';
import Layout from '../../components/Layout/Layout';

const AboutUsPage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Layout title="Sobre a Sambay express">
			<AboutUs />
		</Layout>
	);
};

export default AboutUsPage;
